module.exports = {"page-max-width":1230,"page-focus-width":544,"help-focus-width":328,"page-padding":32,"module-gutter":24,"module-padding":24,"border-thin-width":1,"border-width":2,"border-radius":5,"mobile-padding":4,"element-spacing":8,"watchlist-table-button-column-width":96,"watchlist-table-column-segment-count":15,"breakpoints":[["small",321],["medium",721],["large",1081],["xlarge",1441],["xxlarge",1921]]}


//////////////////
// WEBPACK FOOTER
// ./src/theme/layout-vars.json
// module id = 637
// module chunks = 0 1 2 3 4 5 6 8 11